import styled from '@emotion/styled';

export const PaymentDetailsWrapper = styled('div', { label: 'PaymentDetailsWrapper' })`
    width: calc(100% - 40px);
    height: calc(100% - 80px);
    margin: 60px 20px 20px 20px;
    background-color: white;
`;

export const PaymentDetailsHeader = styled('header', { label: 'PaymentDetailsHeader' })`
    padding: 20px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: scroll;
    white-space: normal;
`;

export const PaymentDetailsTitle = styled('h3', { label: 'PaymentDetailsTitle' })`
    display: block;
    width: 50%;
`;

export const CloseButton = styled('button', { label: 'CloseButton' })`
    padding: 10px;
`;

export const PaymentDetailsButton = styled('button', { label: 'PaymentDetailsButton' })`
    border-radius: 3px;
    border: 1px solid #ccc;
    background: transparent;
    font-weight: bold;
    padding: 0.6em 1em;
    color: #888;
    font-size: 0.95em;
    vertical-align: middle;
    text-decoration: none;
    outline: none;
    line-height: 1em;
`;
